import { useEffect, useState } from 'react';

export type ApiHealth = 'checking' | 'ok' | 'down';

/** Пингует /api/health — заглушка этапа 1, чтобы видеть связку фронт → nginx → API. */
export function useApiHealth(base = ''): ApiHealth {
  const [state, setState] = useState<ApiHealth>('checking');
  useEffect(() => {
    let alive = true;
    fetch(`${base}/api/health`)
      .then((r) => (r.ok ? r.json() : Promise.reject(new Error(String(r.status)))))
      .then(() => alive && setState('ok'))
      .catch(() => alive && setState('down'));
    return () => {
      alive = false;
    };
  }, [base]);
  return state;
}
